import { AppSettings } from "./interfaces/App-Settings";

// Environment-based configuration
const getAppSettings = (): AppSettings => {
    const env = process.env.DEPLOYMENT_ENV || 'local';
    
    console.log('🔧 Environment Detection:');
    console.log('  DEPLOYMENT_ENV:', process.env.DEPLOYMENT_ENV);
    console.log('  NODE_ENV:', process.env.NODE_ENV);
    console.log('  Selected environment:', env);
    
    // You can also override with explicit environment variables
    const API_PATH = process.env.REACT_APP_API_PATH;
    const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
    const REDIRECT_APP_URL = process.env.REACT_APP_REDIRECT_APP_URL;
    
    console.log('🌐 Environment Variables:');
    console.log('  REACT_APP_API_PATH:', API_PATH);
    console.log('  REACT_APP_REDIRECT_URL:', REDIRECT_URL);
    console.log('  REACT_APP_REDIRECT_APP_URL:', REDIRECT_APP_URL);
    
    switch (env) {
        case 'local':
            console.log('🛠️ Using LOCAL configuration');
            return {
                apiPath: API_PATH || "https://localhost:44361",
                redirect: REDIRECT_URL || "http://localhost:8080",
                redirectApp: REDIRECT_APP_URL || "http://localhost:8081"
            };
            
        case 'development':
            console.log('🔧 Using DEVELOPMENT configuration');
            return {
                apiPath: API_PATH || "https://api.dev-baltensperger.chili.ch",
                redirect: REDIRECT_URL || "https://admin.dev-baltensperger.chili.ch",
                redirectApp: REDIRECT_APP_URL || "https://dev-baltensperger.chili.ch"
            };
            
        case 'production':
            console.log('📡 Using PRODUCTION configuration');
            return {
                apiPath: API_PATH || "https://api-baltiapp.baltensperger.ch",
                redirect: REDIRECT_URL || "https://admin-baltiapp.baltensperger.ch",
                redirectApp: REDIRECT_APP_URL || "https://app-baltiapp.baltensperger.ch"
            };
            
        default:
            console.log('⚠️ Using DEFAULT (local) configuration');
            // Fallback to local development
            return {
                apiPath: API_PATH || "https://localhost:44361",
                redirect: REDIRECT_URL || "http://localhost:8080",
                redirectApp: REDIRECT_APP_URL || "http://localhost:8081"
            };
    }
};

const appSettings: AppSettings = getAppSettings();

console.log('📋 Final App Settings:');
console.log('  API Path:', appSettings.apiPath);
console.log('  Redirect URL:', appSettings.redirect);
console.log('  Redirect App URL:', appSettings.redirectApp);

export default appSettings;